import { ModalStyled } from 'components/UI/styled/modal-styled';
import React from 'react';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import { Indicacao } from 'models/indicacoes';
import { format } from 'fecha';
import { Bolsa } from "../models/bolsa";
import {cpfMask} from 'utils/cpf-utils';
import {telMask} from 'utils/tel-utils';
import {getFormattedDate} from "../utils/date-utils";
import {formatMoney} from "../utils/money-utils";
import Form from "react-bootstrap/Form";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  indicacao?: Indicacao;
  bolsa?: Bolsa;
}

const VerDetalhesModal = (props: Props) => {

  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md"
    >
        <ModalStyled.Header closeButton>
          <ModalStyled.Title>
            Detalhes da indicação especial
        </ModalStyled.Title>
        </ModalStyled.Header>

        <ModalStyled.Body>
          <Container fluid className="pl-0 pr-0">
            <Row noGutters>
              <Col>
                {
                <>
                 <div>
                    <label>CPF:</label> <span>{cpfMask(props.indicacao?.cpf)}</span>
                  </div>
                  <div>
                    <label>Nome:</label> <span>{props.indicacao?.nome}</span>
                  </div>
                  <div>
                    <label>Email:</label> <span>{props.indicacao?.email}</span>
                  </div>
                  <div>
                    <label>Data de Indicação:</label> <span>{getFormattedDate(props.indicacao?.dataInsercao)}</span>
                  </div>
                  { props.indicacao?.tipoProduto === 'EXPRESS' &&
                  <>
                    <div>
                      <label>Telefone:</label> <span>{telMask(props.indicacao?.telefone)}</span>
                    </div>
                    <div>
                      <label>Curso:</label> <span>{props.indicacao?.curso?.curso}</span>
                    </div>
                    <div>
                      <label>Convenio:</label> <span>{props.bolsa?.sigla}/{props.indicacao?.curso?.nomeCampus}</span>
                    </div>
                  </>
                  }
                  
                </>
                }
              </Col>
              <Col>
                { props.indicacao?.tipoProduto === 'EXPRESS' &&
                <>
                <div>
                  <label>Solução:</label> <span>{props.bolsa?.solucao}/{props.indicacao?.tipoProduto}</span>
                </div>
                <div>
                  <label>Previsão de formatura:</label> <span>{props.indicacao?.dataFormatura}</span>
                </div>
                <div>
                  <label>Período de contratação:</label> <span>{props.indicacao?.periodoDebito}</span>
                </div>
                <div>
                  <label>Valor contratado:</label> <span>R$ {formatMoney(props.indicacao?.valorContrato)}</span>
                </div>
                <div>
                  <label>Parcelas cobertas:</label> <span>{props.indicacao?.parcelas}</span>
                </div>
                <div>
                  <label>Parcelas de restituição:</label> <span>{props.indicacao?.parcelasRestituicao}</span>
                </div>
                <div>
                  <label>Validade da proposta:</label> <span>de {getFormattedDate(props.indicacao?.dataInicioValidade)} até {getFormattedDate(props.indicacao?.dataFimValidade)}</span>
                </div>
                <div>
                  <label>Início da Restituição:</label> <span>{props.indicacao?.dataInicioRestituicao}</span>
                </div>
                </>
                }

                { props.indicacao?.tipoProduto === 'STANDARD' &&
                <>
                  <div>
                    <label>Convenio:</label> <span>{props.bolsa?.sigla}/{props.indicacao?.curso?.nomeCampus}</span>
                  </div>
                  <div>
                    <label>Solução:</label> <span>{props.bolsa?.solucao}/{props.indicacao?.tipoProduto}</span>
                  </div>
                  <div>
                    <label>Telefone:</label> <span>{props.indicacao?.telefone}</span>
                  </div>
                </>
                }
              </Col>
            </Row>
          </Container>
        </ModalStyled.Body>
    </ModalStyled>
  );
}

export default VerDetalhesModal;